// extracted by mini-css-extract-plugin
module.exports = {"container":"contact-module--container--1EYb9","thumbsUp":"contact-module--thumbs-up--3c6pu","contact":"contact-module--contact--1k6Ho"};